import PropTypes from 'prop-types';
import { BsCheckCircleFill, BsPlus } from 'react-icons/bs';

import PlannedActivityItem from './PlannedActivityItem';

const PlannedSection = ({
	planned,
	editingActivityId,
	renderInlineEditForm,
	resolveIcon,
	isCallActivity,
	members,
	onAddActivity,
	onStartEdit,
	onCheckboxClick,
	onCallReachedSelect,
	onReassign,
	onCancelAutomated,
	onDelete,
}) => (
	<div className="space-y-2.5">
		<h3 className="flex items-center gap-2 text-sm font-semibold text-text">
			Geplant <span className="text-bgBase-800 font-normal text-xs">· {planned.length}</span>
		</h3>
		{planned.length === 0 ? (
			<div className="flex items-center gap-2.5 py-4 px-4 border border-dashed border-bgBase-500 rounded-card bg-bgBase-300 text-bgBase-800 text-xs">
				<BsCheckCircleFill className="w-4 h-4 text-bgBase-800" />
				<span>Keine geplanten Aktivitäten</span>
				<button
					type="button"
					onClick={onAddActivity}
					className="ml-auto text-[11px] text-bgBase-800 hover:text-text transition-colors flex items-center gap-1"
				>
					<BsPlus className="w-3.5 h-3.5" /> Aktivität hinzufügen
				</button>
			</div>
		) : (
			<div className="space-y-2">
				{planned.map((activity) => {
					if (activity.id === editingActivityId) {
						return <div key={activity.id}>{renderInlineEditForm(activity)}</div>;
					}
					return (
						<PlannedActivityItem
							key={activity.id}
							activity={activity}
							Icon={resolveIcon(activity)}
							isCallType={isCallActivity(activity)}
							assignedMember={members.find((m) => m.userId === activity.userId)}
							members={members}
							onStartEdit={onStartEdit}
							onCheckboxClick={onCheckboxClick}
							onCallReachedSelect={onCallReachedSelect}
							onReassign={onReassign}
							onCancelAutomated={onCancelAutomated}
							onDelete={onDelete}
						/>
					);
				})}
			</div>
		)}
	</div>
);

PlannedSection.propTypes = {
	planned: PropTypes.array.isRequired,
	editingActivityId: PropTypes.string,
	renderInlineEditForm: PropTypes.func.isRequired,
	resolveIcon: PropTypes.func.isRequired,
	isCallActivity: PropTypes.func.isRequired,
	members: PropTypes.array.isRequired,
	onAddActivity: PropTypes.func.isRequired,
	onStartEdit: PropTypes.func.isRequired,
	onCheckboxClick: PropTypes.func.isRequired,
	onCallReachedSelect: PropTypes.func.isRequired,
	onReassign: PropTypes.func.isRequired,
	onCancelAutomated: PropTypes.func.isRequired,
	onDelete: PropTypes.func.isRequired,
};

export default PlannedSection;
